'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nitroParagraph = require('../nitro-paragraph');

var _nitroParagraph2 = _interopRequireDefault(_nitroParagraph);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroCard = function (_Component) {
  _inherits(NitroCard, _Component);

  function NitroCard(props) {
    _classCallCheck(this, NitroCard);

    var _this = _possibleConstructorReturn(this, (NitroCard.__proto__ || Object.getPrototypeOf(NitroCard)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(NitroCard, [{
    key: 'handleClick',
    value: function handleClick(e) {
      var action = this.props.action;


      if (action) {
        e.preventDefault();
        action();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          action = _props.action,
          actionText = _props.actionText,
          className = _props.className,
          notificationIcon = _props.notificationIcon,
          notificationIconVariant = _props.notificationIconVariant,
          primaryText = _props.primaryText,
          secondaryText = _props.secondaryText;


      var cardContent = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_styles.Placeholder, { size: 88 }),
        _react2.default.createElement(
          _nitroParagraph2.default,
          { variant: 'secondary', noMargin: true, align: 'center' },
          primaryText
        ),
        _react2.default.createElement(
          _nitroParagraph2.default,
          { size: '1', variant: 'primary', align: 'center', bold: true },
          secondaryText
        ),
        _react2.default.createElement(
          _styles.CardAction,
          null,
          actionText
        )
      );

      return _react2.default.createElement(
        _styles.Card,
        { className: className },
        notificationIcon && _react2.default.createElement(
          _styles.NotificationIcon,
          null,
          _react2.default.createElement(_nitroIcon2.default, {
            variant: notificationIconVariant,
            name: notificationIcon
          })
        ),
        action ? _react2.default.createElement(
          _styles.CardButton,
          { onClick: this.handleClick },
          cardContent
        ) : cardContent
      );
    }
  }]);

  return NitroCard;
}(_react.Component);

NitroCard.propTypes = {
  action: _propTypes2.default.func,
  actionText: _react2.default.PropTypes.string,
  className: _react2.default.PropTypes.string,
  notificationIcon: _propTypes2.default.string,
  notificationIconVariant: _propTypes2.default.string,
  primaryText: _react2.default.PropTypes.string.isRequired,
  secondaryText: _react2.default.PropTypes.string
};

NitroCard.defaultProps = {
  notificationIconVariant: 'secondary'
};

exports.default = NitroCard;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-card/NitroCard.js
// module id = 2891
// module chunks = 4